import { apiWithkey } from "../axios";
import {
  baseApiURL,
  pagamentoCartaoApi,
  pagamentoBoletoApi,
  pagamentoPixApi,
} from "../endpoints";
import {
  setLoadingGifMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useUserStore from "../../storeModules/useUserStore";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import sleepAwait from "../../utils/sleepAwait";
import findStep from "../../screens/bot/stepModules/findStep";
import DatadogErrorReporter from "../../utils/datadogErrorReporter";
import SendPaymentCartaoError from "../../utils/customErrors/sendPaymentCartaoError";
import GetPaymentBoletoError from "../../utils/customErrors/getPaymentBoletoError";
import GetPaymentPixError from "../../utils/customErrors/getPaymentPixError";
import { sendOrderCreatedTag } from "../../gptTags/index";

const fakeLoad = useInitialConfigStore.getState().fakeLoad;

const sendPaymentCartao = async (props) => {
  const url = `${baseApiURL}${pagamentoCartaoApi}`;

  return apiWithkey
    .post(url, props)
    .then((response) => {
      const { status } = response.data;

      if (DatadogErrorReporter.isErrorCode(status)) {
        DatadogErrorReporter.reportApiError(
          new SendPaymentCartaoError(response.data, url, props),
        );
      }
      return response;
    })
    .catch((error) => {
      DatadogErrorReporter.reportApiError(
        new SendPaymentCartaoError(error, url, props),
      );
    });
};

const getPaymentBoleto = async () => {
  setLoadingGifMessage(
    "https://chatbot-cdn.mycon.com.br/consorcio-digital/cards/assets/gerando-boleto.gif",
  );

  const { propostaToken } = useConsorcioStore.getState().fetchedProposta;

  const url = `${baseApiURL}${pagamentoBoletoApi}`;
  const data = JSON.stringify(propostaToken);

  const config = {
    method: "post",
    url,
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    data,
  };

  return apiWithkey
    .request(config)
    .then(async (response) => {
      const { data, status } = response.data;
      const userPaymentData = useUserStore.getState().payment;

      if (DatadogErrorReporter.isErrorCode(status)) {
        DatadogErrorReporter.reportApiError(
          new GetPaymentBoletoError(response.data, url, { propostaToken }),
        );
      }

      useUserStore.setState({
        payment: { ...userPaymentData, boleto: data },
      });

      sendOrderCreatedTag();

      try {
        localStorage.setItem("mycon_payment_boleto", JSON.stringify(data));
      } catch (_) {}

      await sleepAwait(fakeLoad);
      removeLoadingMessage();

      useBotControlStore.setState({
        currentStep: findStep("parabens_boleto").index,
      });
    })
    .catch((error) => {
      DatadogErrorReporter.reportApiError(
        new GetPaymentBoletoError(error, url, { propostaToken }),
      );
      console.log("error --->", error);

      useBotControlStore.setState({
        currentStep: findStep("erro_boleto_tentar_novamente").index,
      });
      removeLoadingMessage();
    });
};

const getPaymentPix = async () => {
  setLoadingGifMessage(
    "https://chatbot-cdn.mycon.com.br/consorcio-digital/cards/assets/pix.gif",
  );

  const { propostaToken } = useConsorcioStore.getState().fetchedProposta;

  const url = `${baseApiURL}${pagamentoPixApi}`;
  const data = JSON.stringify(propostaToken);

  const config = {
    method: "post",
    url,
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    data,
  };

  return apiWithkey
    .request(config)
    .then(async (response) => {
      const payload = response.data ?? {};
      const data = payload.data ?? payload;
      const status = payload.status;
      const userPaymentData = useUserStore.getState().payment;

      if (DatadogErrorReporter.isErrorCode(status)) {
        DatadogErrorReporter.reportApiError(
          new GetPaymentPixError(response.data, url, { propostaToken }),
        );
      }

      useUserStore.setState({
        payment: { ...userPaymentData, pix: data },
      });
      sendOrderCreatedTag();

      try {
        localStorage.setItem("mycon_payment_pix", JSON.stringify(data));
      } catch (_) {}

      await sleepAwait(fakeLoad);
      removeLoadingMessage();

      useBotControlStore.setState({
        currentStep: findStep("conquista_iniciada").index,
      });
    })
    .catch((error) => {
      DatadogErrorReporter.reportApiError(
        new GetPaymentPixError(error, url, { propostaToken }),
      );
      console.log("error --->", error);

      useBotControlStore.setState({
        currentStep: findStep("erro_pix_tentar_novamente").index,
      });
      removeLoadingMessage();
    });
};

export { sendPaymentCartao, getPaymentBoleto, getPaymentPix };
